import styled from "styled-components";

export const TableGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const FlowRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
`;

export const AxisChipsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
`;

export const AxisChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 1rem;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background-color: #f0f2f4;
  font-family: var(--font-pt-serif);
  font-size: 1.4rem;
  font-weight: 700;
  color: #2a2f37;
  white-space: nowrap;
`;

export const AxisChipPlus = styled.span`
  display: inline-flex;
  align-items: center;
  color: #7c899c;
  font-family: var(--font-pt-serif);
  font-size: 1.4rem;
  font-weight: 700;
  flex-shrink: 0;
`;

export const ArrowIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: #7c899c;
  font-size: 1.6rem;
  flex-shrink: 0;
`;

export const AxisRole = styled.b`
  display: inline-flex;
  align-items: center;
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  font-family: var(--font-pt-serif);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
`;
